import { Pipe, PipeTransform } from '@angular/core';

import { PortalFlightItineraryGroupNode } from '@app/services/api/api.types';

@Pipe({
  name: 'getUniqAirlinesLogos',
})
export class GetUniqAirlinesLogosPipe implements PipeTransform {
  transform(flightItineraries: PortalFlightItineraryGroupNode[]) {
    const logoUrls = new Set<string>();

    flightItineraries.forEach((flightItinerary) => {
      flightItinerary.segments.forEach((segment) =>
        logoUrls.add(segment.flightSegment.airline.logoUrl),
      );
    });

    return Array.from(logoUrls);
  }
}
